import { create } from "zustand";

import type { MdmHealthErrorKind } from "@/types/cat/mdm-party-resolution.types";

type MdmClientHealthState = {
  message: string | null;
  errorKind: MdmHealthErrorKind | null;
  setHealthError: (
    payload: { message: string; errorKind: MdmHealthErrorKind } | null,
  ) => void;
  clearMessage: () => void;
};

export const useMdmClientHealthStore = create<MdmClientHealthState>((set) => ({
  message: null,
  errorKind: null,
  setHealthError: (payload) =>
    set((state) => {
      if (!payload) {
        if (state.message === null && state.errorKind === null) {
          return state;
        }
        return { message: null, errorKind: null };
      }

      if (
        state.message === payload.message &&
        state.errorKind === payload.errorKind
      ) {
        return state;
      }

      return { message: payload.message, errorKind: payload.errorKind };
    }),
  clearMessage: () => set({ message: null, errorKind: null }),
}));
